import React, { Fragment, useEffect, useState } from "react"
import Button from "../../components/generic/buttons/Button"
import { Link, NavLink, useHistory, useLocation } from "react-router-dom"
import store from "../../app/Store"
import { NotificationKind, notify } from "../../containers/notificationSlice"
import { routeMap } from "../../components/generic/navbar/routeMap"
import { HandlingApp, PageId } from "../../common/pageId"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { LoginContent, PageContent } from "../../common/pageText"

import { login3, requestUserPermissions } from "../../api/BackendCalls"
import { logonUser } from "../../containers/applicationSlice"
import { CommonText } from "../../common/text"
import { LoadingPanel } from "../../components/generic"

export const Home: React.FunctionComponent = () => {
  const history = useHistory<{ from: any }>()
  const { pathname } = useLocation()
  const { userInfo, menu, versionInfo } = useAppSelector(
    (state) => state["appReducer"]
  )

  const dispatch = useAppDispatch()
  const [showAlert, setShowAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const isPPR = versionInfo.handlingApplication === HandlingApp.FRAPORTGR
  const pageId = PageId.DefaultPage
  useEffect(() => {
    if (history.location.state) {
      const _pathName = history.location.state.from.pathname
        .split("/")[1]
        .toLowerCase()
      const menuItemExist = menu.items.find(
        (menuItem) =>
          menuItem.pageId === _pathName ||
          menuItem.items.find((i) => i.pageId.toLowerCase() === _pathName)
      )
      if (!menuItemExist && _pathName !== "login") {
        setShowAlert(true)
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (showAlert && history.location.state) {
      const _pathName = history.location.state.from.pathname.replace("/", "")

      store.dispatch(
        notify({
          kind: NotificationKind.ERROR,
          title: "",
          message: "Not authorized for page " + _pathName
        })
      )
      setShowAlert(false)
    }
    // eslint-disable-next-line
  }, [showAlert])

  // HTTP header authN - cf. also loginDialog/index.tsx
  const loginByHttpHeader = async () => {
    if (versionInfo.useHeaderAuth) {
      setLoading(true)
      const result = await login3(pageId, {})
      setLoading(false)

      if (result) {
        requestUserPermissions(pageId)
        dispatch(logonUser({ loginName: result.userName, authenticated: true }))
      } else {
        store.dispatch(
          notify({
            kind: NotificationKind.ERROR,
            title: "",
            message: "Single sign on failed - please contact us"
          })
        )
      }
    }
  }

  return (
    <Fragment>
      {loading && (
        <LoadingPanel visible={true} loadingTxt="Loading Response..." />
      )}
      <div className="h-100p ocs-pt-88 home-info">
        <div
          className={`home-info-container d-flex flex-column justify-content-between ${
            isPPR ? "ppr-home-info" : ""
          }`}
        >
          <div>
            {isPPR ? (
              <>
                <h1>Fraport Greece PPR Platform</h1>
                <p>
                  Fraport Greece PPR platform is a powerful system for the
                  management of PPR (Prior Permission Required) for General and
                  Business Aviation Flights, State, Military, Training,
                  Ambulance and Helicopter Flights at airports operated by
                  Fraport Greece.
                </p>
                <p>
                  PPR Platform provides real-time parking position availability.
                  Authorized users can make online requests to add, change and
                  delete PPRs and get immediate responses, including automatic
                  offers.
                </p>
                <p>
                  Access to PPR Platform is given to Ground Handling Services
                  Providers (GHSP) with a valid Category 1 license by HCAA
                  conforming to the Basic Ground Handling Regulation.
                </p>
                <p>
                  Additional information for the PPR Procedure and Guidelines is
                  available
                  <a
                    href="https://www.fraport-greece.com/eng/our-expertise-and-services/aviation/ppr-procedure-and-guidelines"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  .
                </p>
              </>
            ) : (
              <>
                <h1>Online Coordination System</h1>
                <p>
                  The Online Coordination System (OCS) is a powerful system that
                  allows users to access coordinator’s databases for airports
                  around the world.
                </p>
                <p>
                  OCS provides real-time airport slot availability displays, and
                  OCS users can view and download the latest schedule
                  information.
                </p>
                <p>
                  Authorised users can make online requests to add, change and
                  delete slots and get immediate responses, including automatic
                  offers, and the ability to coordinate slots at multiple
                  airports at the same time.
                </p>
              </>
            )}
            {!userInfo.authenticated && (
              <span className="d-flex justify-content-center ocs-mt-52">
                <NavLink
                  className="login-btn"
                  to={{
                    pathname: versionInfo.useHeaderAuth ? "/" : "/login",
                    state: { from: { pathname: pathname } }
                  }}
                >
                  <Button
                    onClick={loginByHttpHeader}
                    variant="primary"
                    className="w-100p  mq-btn-height"
                  >
                    {CommonText.login}
                  </Button>
                </NavLink>
              </span>
            )}
          </div>

          {!userInfo.authenticated && (
            <div>
              <span className="promo-video-link">
                {LoginContent.prompVideoText} -
                <a
                  href="https://www.youtube.com/watch?v=ZKKvoOp-hAM"
                  target="_blank"
                  rel="noreferrer"
                >
                  {LoginContent.watchTheVideo}
                </a>
              </span>
              <span className="mq-flex-direction-row d-flex justify-content-center">
                Don't have an account?{" "}
                <Link to={routeMap[PageId.ContactUs]}>
                  {PageContent.contactUs}
                </Link>
              </span>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}
